<template>
    <div class="col flex flex-column">
        <div v-if="isDemo" class="grid">
            <div class="col">
                <Message
                    severity="info"
                    :closable="false"
                    :pt="{
                        icon: { style: 'width: 23px; flex-shrink: 0;', class: 'mr-4' },
                        wrapper: { class: 'align-items-start' }
                    }"
                >
                    <h4 class="mb-3 mt-1 text-sm">{{ $t('lang.group.start.demo_title') }}</h4>
                    <div class="grid group_start__demo_content">
                        <div class="col-12 pb-0">
                            {{ $t('lang.group.start.demo_link_1') }}
                            <a :href="'/' + getLocale + '/group/7d38039eaf71315dde6337a1e76211a7?db=msk'">
                                {{ $t('lang.group.start.demo_link_label') }}
                            </a>
                        </div>
                        <div class="col-12">
                            {{ $t('lang.group.start.demo_link_2') }}
                            <a :href="'/' + getLocale + '/group/4b1293a01e2a22936d0cded6bbad8517?db=msk'">
                                {{ $t('lang.group.start.demo_link_label') }}
                            </a>
                        </div>
                    </div>
                </Message>
            </div>
        </div>
        <div class="grid">
            <div class="col relative group_start__table_container">
                <AdaptersLoader :loading="loading" />
                <AdaptersDataTable v-if="tableData" :params="getTableParams" @page="update" @sort="update">
                    <Column field="name" :header="$t('lang.group.start.column_name')" sortable>
                        <template #body="{ data }">
                            <div class="flex align-items-center justify-content-between">
                                <a :href="getReportUrl(data.rid, data.base)">{{ data.name }}</a>
                                <i
                                    v-if="isShowOwnerEmail(data.owner)"
                                    :title="$t('lang.main.owner_email', [data.owner])"
                                    class="pi pi-users text-color-secondary ml-2 text-sm"
                                ></i>
                            </div>
                        </template>
                    </Column>
                    <Column field="create_date" :header="$t('lang.group.start.column_date_create')" sortable />
                    <Column field="access_date" :header="$t('lang.group.start.column_date_update')" sortable />
                    <Column field="base" :header="$t('lang.group.start.column_dbname')" sortable>
                        <template #body="{ data }">
                            <span>{{ getBaseCaption(data.base) }}</span>
                        </template>
                    </Column>
                    <Column field="top" :header="$t('lang.group.start.column_top')" sortable />
                    <Column field="state" :header="$t('lang.group.start.column_status')" sortable>
                        <template #body="{ data }">
                            <span>{{ getState(data.state) }}</span>
                        </template>
                    </Column>
                    <Column>
                        <template #body="{ data }">
                            <div class="flex justify-content-end column-gap-2">
                                <Button
                                    v-if="data.canChangeOwner"
                                    icon="pi pi-users"
                                    size="small"
                                    severity="secondary"
                                    text
                                    :title="$t('lang.group_report.change_owner_report_name', [data.name])"
                                    @click="onChangeOwner(data)"
                                />
                                <Button
                                    v-if="isCanDelete(data)"
                                    icon="pi pi-trash"
                                    size="small"
                                    severity="secondary"
                                    text
                                    :title="$t('lang.group_report.delete_report_name', [data.name])"
                                    @click="onDeleteReport(data)"
                                />
                            </div>
                        </template>
                    </Column>
                </AdaptersDataTable>
                <ks-delete-group-report></ks-delete-group-report>
                <ks-change-report-owner></ks-change-report-owner>
            </div>
        </div>
    </div>
</template>

<script>
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Languages from "../../../mixins/Languages";
import Button from "primevue/button";
import {Listeners} from "../../../constants/listeners";
import TableReport from "../../../component/table/Report.vue";
import KsChangeReportOwner from "./KSChangeReportOwner.vue";
import KsDeleteGroupReport from "./KSDeleteGroupReport.vue";
import GroupReportApi from "../../../api/GroupReportApi";
import {TableHelper} from "../../../helpers/TableHelper";
import Paginator from "primevue/paginator";
import AdaptersDataTable from "../../../component/adapters/DataTable.vue";
import Alerts from "../../../mixins/Alerts";
import Message from "primevue/message";
import AdaptersLoader from "../../../component/adapters/Loader.vue";

export default {
    name: "GroupStart",
    mixins: [
        Languages,
        Alerts,
    ],
    props: {
        isDemo: {
            type: Boolean,
            required: true,
        },
        dbname: {
            type: String,
            required: true,
        },
        domains: {}
    },
    data() {
        return {
            loading: false,
            error: null,
            info: null,
            tableData: null,
            sortField: 'access_date',
            rowsPerPage: TableHelper.getDefaultRowsPerPage(),
            page: 1,
            sortOrder: -1,
            first: 0,
        };
    },
    mounted() {
        this.loadData();
        this.$emitter.on(Listeners.RELOAD_GROUP_REPORTS_LIST, () => this.loadData());
    },
    methods: {
        update(event) {
            this.sortField = event.sorted;
            this.sortOrder = event.sortOrder ?? this.sortOrder;
            this.rowsPerPage = event.rows;
            this.page = event.page ? event.page + 1 : 1;
            this.first = event.first;

            this.loadData();
        },
        loadData() {
            // if (this.tableData) {
                this.loading = true;
            // } else {
            //     this.$emitter.emit(Listeners.CONTENT_PRELOADER_SHOW);
            // }
            GroupReportApi
                .getReportList({
                    'sort': this.sortField + '|' + this.getSortOrder,
                    'page': this.page,
                    'per_page': this.rowsPerPage
                })
                .then(response => this.tableData = response)
                .catch(error => this.alertError(error))
                .finally(() => this.loading = false);
        },
        getReportUrl(rid, base) {
            return sprintf('/%s/group/%s?db=%s', window.locale, rid, base);
        },
        onChangeOwner(rowData) {
            this.$emitter.emit(Listeners.KS_CHANGE_OWNER_REPORT, rowData);
        },
        onDeleteReport(rowData) {
            this.$emitter.emit(Listeners.KS_DELETE_REPORT, rowData);
        },
        isCanDelete(rowData) {
            return rowData.state === 10 || rowData.state === 2;
        },
        isShowOwnerEmail(owner) {
            return owner !== this.$store.getters.USER.email;
        },
    },
    computed: {
        getSortOrder() {
            return TableHelper.getEncodeSortOrder(this.sortOrder);
        },
        getLocale() {
            return window.locale;
        },
        getTableParams() {
            return {
                value: this.tableData.data,
                rows: this.tableData.per_page,
                totalRecords: this.tableData.total,
                sortField: this.sortField,
                sortOrder: this.sortOrder,
                first: this.first,
            };
        },
    },
    components: {
        DataTable,
        Column,
        Button,
        TableReport,
        Message,
        KsChangeReportOwner,
        KsDeleteGroupReport,
        Paginator,
        AdaptersDataTable,
        AdaptersLoader,
    }
}
</script>

<style scoped>
.group_start__demo_content {
    font-size: 13px;
}
.group_start__table_container {
    min-height: 100px;
}
</style>
